export default __webpack_public_path__ + "static/nativo-e417b8c0652ddf10c26ed610033446e2.png";